import { handleClickChatUs } from 'client/javascript/nav';
import { setUpContactUsOverlay, OPEN_CONTACT_US_BTN_ID } from 'client/javascript/contact_us/overlay';
import setUpContactUsForm from 'client/javascript/contact_us/form';

export default function hookUpContactUs() {
  handleClickChatUs();

  if (!document.getElementById(OPEN_CONTACT_US_BTN_ID)) {
    return;
  }

  setUpContactUsOverlay();
  setUpContactUsForm();
}
